/* global translation */

import { triggerEvent } from './functions';

const miniCartContainer = document.querySelector('.widget_shopping_cart');
const miniCartButtons = Array.from(document.getElementsByClassName('toggle-mini-cart'));

miniCartButtons.forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();

    document.body.classList.remove('open-mini-wishlist');
    document.body.classList.toggle('open-mini-cart');
  });
});

jQuery(document).on('change', 'li.woocommerce-mini-cart-item .mini-cart-right .right-bottom select.qty', (event) => {
  event.preventDefault();
  const qtyInput = event.currentTarget;
  const cartItemId = jQuery(qtyInput).closest('li.woocommerce-mini-cart-item').data('cart-item-key');
  const qty = qtyInput.value;
  miniCartContainer.classList.add('wait');

  jQuery.post(translation.ajaxurl, { action: 'maksimer_woocommerce_cart_update_qty', cart_item_key: cartItemId, quantity: qty }, () => {
    triggerEvent(document.body, 'wc_fragment_refresh');
    setTimeout(() => {
      miniCartContainer.classList.remove('wait');
    }, 500);
  });
});
